module.exports = __webpack_public_path__ + "./images/Marketing.4741eff1bb0106d7758ab29a96f64f05.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/Marketing.png
// module id = ./websources/public/images/Marketing.png
// module chunks = 0